import { render, staticRenderFns } from "./shopping-cart.vue?vue&type=template&id=53339a82"
import script from "./shopping-cart.vue?vue&type=script&lang=js"
export * from "./shopping-cart.vue?vue&type=script&lang=js"
import style0 from "./shopping-cart.vue?vue&type=style&index=0&id=53339a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports